// Generated by ReScript, PLEASE EDIT WITH CARE


function toString(vehicle) {
  switch (vehicle) {
    case /* TwoWheeler */0 :
        return "2 Wheeler";
    case /* ThreeWheeler */1 :
        return "3 Wheeler";
    case /* PickupDostSuperAce8ft */2 :
        return "Pickup / Dost / Super Ace / 8ft";
    case /* Pickup8ft */3 :
        return "Pickup / 8ft";
    case /* Pickup8ft1Ton */4 :
        return "Pickup / 8ft 1Ton";
    case /* Pickup8ft1Dot3Ton */5 :
        return "Pickup / 8ft 1.3Ton";
    case /* Pickup8ftOpen */6 :
        return "Pickup 8ft Open";
    case /* TataAce */7 :
        return "Tata Ace";
    case /* TataAceOpen */8 :
        return "Tata Ace Open";
    case /* AceHelper */9 :
        return "Ace Helper";
    case /* SuperAce8ft */10 :
        return "Super Ace 8ft";
    case /* Tata407 */11 :
        return "Tata 407";
    case /* Tata407_14ft */12 :
        return "Tata 407 14ft";
    case /* Eeco */13 :
        return "Eeco";
    case /* ChampionHelper */14 :
        return "Champion Helper";
    case /* Champion */15 :
        return "Champion";
    case /* TataAceClosed */16 :
        return "Tata Ace Closed";
    case /* ThreeWheelerHelper */17 :
        return "3 Wheeler Helper";
    case /* ThreeWheelerMini */18 :
        return "3 Wheeler Mini";
    case /* PorterHire */19 :
        return "Porter Hire";
    case /* Rental */20 :
        return "Rental";
    case /* AceHelperPlusOneHelper */21 :
        return "Ace Helper + 1 Labour";
    case /* Canter3Tonne */22 :
        return "Canter - 3 Tonne";
    case /* Pickup1Tonne */23 :
        return "Pickup - 1 Tonne";
    
  }
}

function fromString(vehicle) {
  var match = vehicle.trim();
  switch (match) {
    case "2 Wheeler" :
        return /* TwoWheeler */0;
    case "3 Wheeler" :
        return /* ThreeWheeler */1;
    case "3 Wheeler Helper" :
        return /* ThreeWheelerHelper */17;
    case "3 Wheeler Mini" :
        return /* ThreeWheelerMini */18;
    case "Ace Helper" :
        return /* AceHelper */9;
    case "Ace Helper + 1 Labour" :
        return /* AceHelperPlusOneHelper */21;
    case "Canter - 3 Tonne" :
        return /* Canter3Tonne */22;
    case "Champion" :
        return /* Champion */15;
    case "Champion Helper" :
        return /* ChampionHelper */14;
    case "Eeco" :
        return /* Eeco */13;
    case "Pickup - 1 Tonne" :
        return /* Pickup1Tonne */23;
    case "Pickup / 8ft" :
        return /* Pickup8ft */3;
    case "Pickup / 8ft 1.3Ton" :
        return /* Pickup8ft1Dot3Ton */5;
    case "Pickup / 8ft 1Ton" :
        return /* Pickup8ft1Ton */4;
    case "Pickup / Dost / Super Ace / 8ft" :
        return /* PickupDostSuperAce8ft */2;
    case "Porter Hire" :
        return /* PorterHire */19;
    case "Rental" :
        return /* Rental */20;
    case "Super Ace 8ft" :
        return /* SuperAce8ft */10;
    case "Tata 407" :
        return /* Tata407 */11;
    case "Canter 14ft" :
    case "Tata 407 14ft" :
        return /* Tata407_14ft */12;
    case "Tata Ace" :
        return /* TataAce */7;
    case "Tata Ace Closed" :
        return /* TataAceClosed */16;
    case "Tata Ace Open" :
        return /* TataAceOpen */8;
    default:
      return /* TataAce */7;
  }
}

export {
  toString ,
  fromString ,
  
}
/* No side effect */
